import React, { ChangeEvent, FormEvent, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { CategorySummary, getCategories } from "./services/api";
import { RETURN_HOME_EVENT, START_CATEGORY_EVENT, StartCategoryEventDetail } from "./events";
import "./heading.css";

const CATEGORY_QUERY_KEY = ["categories-v1"];

function Heading() {
    const [selectedCategory, setSelectedCategory] = useState("");
    const categoriesQuery = useQuery<CategorySummary[]>({
        queryKey: CATEGORY_QUERY_KEY,
        queryFn: async () => {
            const { data } = await getCategories();
            return data;
        },
    });

    function handleLogoClick() {
        window.dispatchEvent(new Event(RETURN_HOME_EVENT));
    }

    function handleCategoryChange(event: ChangeEvent<HTMLSelectElement>) {
        const category = event.target.value;
        setSelectedCategory("");

        if (!category) {
            return;
        }

        window.dispatchEvent(new CustomEvent<StartCategoryEventDetail>(START_CATEGORY_EVENT, {
            detail: { category },
        }));
    }

    function handleSearchSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
    }

    const categories: CategorySummary[] = categoriesQuery.data || [];

    return (
        <div className="header">
            <header className="site-header">
                <h1 className="visually-hidden">eBaydle</h1>
                <button className="logo-button" type="button" onClick={handleLogoClick} aria-label="Return to category selection">
                    <span className="ebay-font" aria-hidden="true">
                        <span className="logo-letter red">e</span>
                        <span className="logo-letter blue">b</span>
                        <span className="logo-letter yellow">a</span>
                        <span className="logo-letter green">y</span>
                        <span className="logo-letter red logo-tail">d</span>
                        <span className="logo-letter blue">l</span>
                        <span className="logo-letter yellow">e</span>
                    </span>
                </button>
                <button className="category-button" type="button">Guess by<br />category</button>
                <form className="search-bar" onSubmit={handleSearchSubmit}>
                    <span className="search-icon" aria-hidden="true"></span>
                    <input aria-label="Search" placeholder="I don't do anything :>" disabled />
                    <select aria-label="Category" value={selectedCategory} onChange={handleCategoryChange}>
                        <option value="">All Categories</option>
                        {categories.map((category) => (
                            <option key={category.category} value={category.category}>
                                {category.category}
                            </option>
                        ))}
                    </select>
                </form>
            </header>
            <div className="promo-strip">
                <a className="promo-strip-inner" href="https://github.com/joe-mcintyre" target="_blank" rel="noreferrer">
                    <strong>LIVE</strong>
                    <span>Scraping 1000 new items every day!</span>
                    <span className="promo-strip-button">Click Me</span>
                </a>
            </div>
        </div>
    );
}

export default Heading;
